<sk-button
  [appearance]="'icon'"
  (click)="removeLink()"
  clickStopPropagation
  [matTooltip]="'label.RemoveLink' | translate"
  data-test="dms-unlink-file-to-file-button-remove-link-button"
>
  <i class="icon far fa-unlink"></i>
</sk-button>
